import { useContext } from "react";

import { TypographyContext } from "./TypographyProvider";

export const useTypographyContext = () => useContext(TypographyContext);
